import {
  AfterViewChecked,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  signal,
  ViewChild,
  WritableSignal,
} from '@angular/core';
import { ArrowRight1IconComponent } from '../icons/generated/arrow-right-1/arrow-right-1.component';
import { AkitaScreenQuery } from '@app/akita/screen/state/screen.query';
import { toSignal } from '@angular/core/rxjs-interop';
import { ArrowLeft1IconComponent } from '../icons/generated/arrow-left-1/arrow-left-1.component';
import { AkitaRouterQuery } from '@app/akita/router/state/router.query';

@Component({
  selector: 'app-popsy-scroller',
  templateUrl: './popsy-scroller.template.html',
  styleUrls: ['./popsy-scroller.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ArrowRight1IconComponent, ArrowLeft1IconComponent],
})
export class PopsyScrollComponent implements AfterViewChecked {
  @Input() public display: string | null = null;

  public readonly biggerThan = toSignal(this.akitaScreenQuery.selectBiggerThan());
  public readonly isRtl = toSignal(this.akitaRouterQuery.selectIsRtlLayout());

  public showArrowRight: WritableSignal<boolean> = signal(false);
  public showArrowLeft: WritableSignal<boolean> = signal(false);

  @ViewChild('scrollableContainer') private readonly scrollContainerRef!: ElementRef;

  constructor(
    private readonly akitaScreenQuery: AkitaScreenQuery,
    private readonly akitaRouterQuery: AkitaRouterQuery
  ) {
    this.checkScrolls = this.checkScrolls.bind(this);
  }

  public ngAfterViewChecked(): void {
    if (this.scrollContainerRef) {
      this.checkScrolls(this.scrollContainerRef.nativeElement);
    }
  }

  public checkScrolls(container: HTMLElement): void {
    if (this.isRtl() === true) {
      // RTL-specific logic
      this.showArrowRight.set(
        container.scrollLeft < 0 &&
          Math.abs(container.scrollLeft) + container.clientWidth <= container.scrollWidth
      );
      this.showArrowLeft.set(
        container.scrollLeft <= 0 &&
          Math.abs(container.scrollLeft) + container.clientWidth < container.scrollWidth
      );
    } else {
      this.showArrowRight.set(
        container.scrollWidth > container.clientWidth &&
          container.scrollLeft + container.clientWidth < container.scrollWidth
      );
      this.showArrowLeft.set(container.scrollLeft > 0);
    }
  }

  public scrollRight(container: HTMLElement): void {
    container.scrollBy({ left: 200, behavior: 'smooth' });
  }

  public scrollLeft(container: HTMLElement): void {
    container.scrollBy({ left: -200, behavior: 'smooth' });
  }
}
